import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  addTemplates: {
    method: 'POST',
    url: `${configs.baseUrl}/api/admin/collection/{collectionId}/template`,
  },
  deleteTemplate: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/admin/collection/{collectionId}/template/{templateId}`,
  },
  getDetails: {
    method: 'GET',
    url: `${configs.baseUrl}/api/admin/collection/{collectionId}`,
  },
  getList: {
    method: 'GET',
    url: `${configs.baseUrl}/api/admin/collection/`,
  }
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const addTemplates = async (collectionId, params) => {
  const res = await resource.addTemplates({ collectionId }, params)

  return res && res.body && res.body.data
}

const deleteTemplate = async (collectionId, templateId) => {
  const res = await resource.deleteTemplate({ collectionId, templateId })

  return res && res.body && res.body.data
}

const getDetails = async (collectionId) => {
  const res = await resource.getDetails({ collectionId })
  
  return res && res.body && res.body.data
}

export default {
  initResource,
  addTemplates,
  deleteTemplate,
  getDetails,
}
